import { PageTabsWrapper } from "@/common/styles";
import { useMemo } from "react";
import Tabs from "../Tabs";
import ArrestBook from "./ArrestBook";
import Docs from "./Docs";
import HouseTrackInmate from "./HouseTrackInmate";
import FolderFlags from "@/components/FolderFlags";
import MedicalInfo from "./MedicalInfo";
import Personal from "./Personal";
import Property from "./Property";
import BookingAdministrativeInformation from "../BookingsDetails/BookingAdministrativeInformation";

export const INMATE_DETAILS_MODE = { EDIT: "EDIT", VIEW: "VIEW" };

const InmateDetails = ({
  personalFormRef,
  arrestbookFormRef,
  houseFormRef,
  folderFlagsRef,
  medicalRef,
  propertyRef,
  docsRef,
  continueBtnRef,
  nextButtonClick,
}) => {
  const tabs = useMemo(
    () => [
      {
        key: "personal",
        title: "Personal",
        disabled: false,
        component: Personal,
        ref: personalFormRef,
      },
      {
        key: "arrestBook",
        title: "Arrest & Book",
        component: ArrestBook,
        disabled: true,
        ref: arrestbookFormRef,
      },
      {
        key: "houseTrack",
        title: "House & Track",
        disabled: true,
        component: HouseTrackInmate,
        ref: houseFormRef,
      },
      {
        key: "jacketFlags",
        title: "Folder Flags",
        disabled: true,
        component: FolderFlags,
        ref: folderFlagsRef,
      },
      {
        key: "medicalInfo",
        title: "Medical Info",
        disabled: true,
        component: MedicalInfo,
        ref: medicalRef,
      },
      {
        key: "property",
        title: "Property",
        component: Property,
        disabled: true,
        ref: propertyRef,
      },
      {
        key: "docs",
        title: "Docs",
        component: Docs,
        disabled: true,
        ref: docsRef,
      },
       {
          title: "Administrative Information",
          key: "administrative-information",
          disabled: true,
          component: BookingAdministrativeInformation                        
        },
    ],
    []
  );

  return (
    <>
      <PageTabsWrapper>
        <Tabs
          ref={continueBtnRef}
          tabs={tabs}
          defaultActiveTab={tabs[0]?.key}
          navControls
          onNextClickTrigger={nextButtonClick}
          tabProps={{
            personal: {
              personalFormRef: personalFormRef,
              startingPoint:"CreateBooking"
            },
            arrestBook: {
              arrestbookFormRef: arrestbookFormRef,
            },
            houseTrack: {
              houseFormRef: houseFormRef,
            },
            jacketFlags: {
              folderFlagsRef: folderFlagsRef,
            },
            medicalInfo: {
              medicalRef: medicalRef,
            },
            property: {
              propertyRef: propertyRef,
            },
            docs: { docsRef: docsRef },
          }}
        />
      </PageTabsWrapper>
    </>
  );
};

export default InmateDetails;
